import {
  Component,
  ViewEncapsulation,
  ComponentRef,
  EventEmitter,
  Output,
  ChangeDetectorRef,
  Input,
  ViewChild
} from '@angular/core';
import { Location } from '@angular/common';

import { ModalComponent } from '../../../modal/modal.component';
import { EditObservationMenuComponent } from '../../../menus/index';
import { AddInstallationObservationComponent } from './add-observation.component';
import * as _ from 'lodash';
import { InstallationObservationPluginService } from './observationsandrecommandations-plugin.service';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'inst-edit-observation',
    templateUrl: './edit-observation.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EditInstallationObservationComponent extends BaseInstallationEditPageComponent {
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('addObservation', { static: true })
  addObservationModal: AddInstallationObservationComponent;
  @ViewChild('reparatorModal', { static: true })
  modal: ModalComponent;

  @Input()
  responsibles: any;
  @Input()
  priorities: any;
  @Input()
  machines: any;
  public selectedMachines: any = {};
  public unitedMachines: any[];
  public isAllMachines = false;
  plugin: any;
  @Output()
  public toggleSave: EventEmitter<any> = new EventEmitter();
  @Output()
  public toggleRemove: EventEmitter<any> = new EventEmitter();
  @Output()
  public toggleCancel: EventEmitter<any> = new EventEmitter();
  public isOpen = false;
  cmpRef: ComponentRef<any>;
  @Output()
  public modalClosed: EventEmitter<any> = new EventEmitter();

  public component: any;
  public observation: any;
  public reparators: any;
  public currentTimeToRepairItem: any;

  updateObservationSelection() {
    this.observation.Selected = !this.observation.Selected;
  }

  isSelectedObservation() {
    return this.observation.Selected;
  }

  isCheckedProductivity() {
    return this.observation.Impact.Productivity;
  }

  updateProductivitySelection() {
    this.observation.Impact.Productivity = !this.observation.Impact.Productivity;
  }

  isCheckedSetup() {
    return this.observation.Impact.Setup;
  }

  isCheckedAvailability() {
    return this.observation.Impact.Availability;
  }

  updateSetupSelection() {
    this.observation.Impact.Setup = !this.observation.Impact.Setup;
  }

  updateAvailabilitySelection() {
    this.observation.Impact.Availability = !this.observation.Impact.Availability;
  }

  isCheckedSafety() {
    return this.observation.Impact.Safety;
  }

  updateSafetySelection() {
    this.observation.Impact.Safety = !this.observation.Impact.Safety;
  }

  isCheckedQuality() {
    return this.observation.Impact.Quality;
  }

  updateQualitySelection() {
    this.observation.Impact.Quality = !this.observation.Impact.Quality;
  }

  isObservationMachine(m: any) {
    return this.getMachineById(m);
  }

  isSelectedMachine(index: number) {
    return this.selectedMachines[index].Selected;
  }

  getMachineById(m: any) {
    return (
      this.observation.Machines &&
      this.observation.Machines.length &&
      _.findIndex(
        this.observation.Machines,
        (el) => el.ModelId === m.ModelId && (!m.SerialNumber || el.SerialNumber === m.SerialNumber)
      ) !== -1
    );
  }

  updateMachineSelection(index: number) {
    let isAllMachines = true;
    this.selectedMachines[index].Selected = !this.selectedMachines[index].Selected;
    _.values(this.selectedMachines).forEach((machine) => {
      if (!machine.Selected) {
        isAllMachines = false;
      }
    });
    this.isAllMachines = isAllMachines;
  }

  isAnyMachineSelected(): boolean {
    return _.values(this.selectedMachines).some((m) => m.Selected);
  }

  updateAllMachines() {
    this.isAllMachines = !this.isAllMachines;
    this.isAllMachines
      ? _.values(this.selectedMachines).forEach((m) => (m.Selected = true))
      : _.values(this.selectedMachines).forEach((m) => (m.Selected = false));
  }

  initMachines() {
    this.selectedMachines = [];
    let anyMachineSelected = false;
    if (this.unitedMachines && this.unitedMachines.length > 0) {
      this.isAllMachines = true;
    }
    _.each(this.unitedMachines, (m: any) => {
      if (this.isObservationMachine(m)) {
        m.Selected = true;
        anyMachineSelected = true;
      } else {
        m.Selected = false;
        this.isAllMachines = false;
      }

      this.selectedMachines.push(m);
    });

    if (!this.isAllMachines && !anyMachineSelected) {
      this.updateAllMachines();
    }
  }

  public getMachines() {
    return this.selectedMachines;
  }

  public save() {
    this.dispose();
    const selectedMachines = _.filter(this.selectedMachines, 'Selected');
    this.observation.Machines = selectedMachines;

    this.toggleSave.emit(this.observation);
  }

  public cancel() {
    this.dispose();
    this.toggleCancel.emit();
  }

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationObservationPluginService,
    private cdf: ChangeDetectorRef
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  open(observation: any) {
    this.observation = observation;
    if (this.machines) {
      this.unitedMachines = [...this.machines];
    }
    this.initMachines();
    if (!this.observation.Parts || this.observation.Parts.length === 0) {
      this.observation.Parts = [];
    }
    this.isOpen = true;
    this.cdf.detectChanges();
  }

  dispose() {
    this.isOpen = false;
    if (this.component !== undefined) {
      this.component.then((componentRef: ComponentRef<any>) => {
        componentRef.destroy();
        return componentRef;
      });
    }
  }

  close() {
    this.dispose();
  }

  public openMenu(): void {
    this.menuModal.modalFooter = false;
    this.menuModal.modalHeader = false;
    this.menuModal.modalMessage = false;
    this.menuModal.open(EditObservationMenuComponent);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 2:
        this.openEditObservation();
        break;
      default:
    }
  }

  public deleteObservation() {
    this.dispose();
    this.toggleRemove.emit(this.observation);
  }

  public openEditObservation() {
    this.addObservationModal.open(this.observation);
  }

  isResponsible(resp: any): boolean {
    return this.observation.Responsible === resp.value;
  }

  isPriority(prio: any): boolean {
    return this.observation.Priority === prio.value;
  }

  changeResponsible(resp: any) {
    this.observation.Responsible = resp.value;
  }

  changePriority(prio: any) {
    this.observation.Priority = prio.value;
  }

  updateQuantity(part: any, quantity: number) {
    if (part.Quantity > 0 || (part.Quantity === 0 && quantity > 0)) {
      part.Quantity = part.Quantity + quantity;
    }
  }

  removeParts(i: number) {
    this.observation.Parts.splice(i, 1);
  }

  addParts() {
    this.observation.Parts.push({});
  }

  saveEditObservation() {}
}
